import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function SaisonAuswahlPage() {
  const navigate = useNavigate();
  const [saisons, setSaisons] = useState([]);
  const [loading, setLoading] = useState(true);

  // NFL Team Logos für Hintergrund
  const NFL_TEAM_LOGOS = [
    'https://a.espncdn.com/i/teamlogos/nfl/500/ari.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/bal.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/buf.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/car.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/chi.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/cin.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/cle.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/dal.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/den.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/det.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/gb.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/hou.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/ind.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/jax.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/kc.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/lac.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/lar.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/lv.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/mia.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/min.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/ne.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/no.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/nyj.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/phi.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/pit.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/sea.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/sf.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/tb.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/ten.png',
    'https://a.espncdn.com/i/teamlogos/nfl/500/wsh.png'
  ];

  const NFL_LOGO = 'https://a.espncdn.com/i/teamlogos/leagues/500/nfl.png';

  useEffect(() => {
    ladeSaisons();
  }, []);

  const ladeSaisons = async () => {
    try {
      // Lade alle Saison-Konfigurationen
      const configSnapshot = await getDocs(collection(db, 'saisonKonfiguration'));
      
      const saisonDaten = [];
      
      for (const configDoc of configSnapshot.docs) {
        const config = configDoc.data();
        const saisonId = configDoc.id;
        
        saisonDaten.push({
          id: saisonId,
          name: saisonId.replace('-', '/'),
          gesperrt: config.gesperrt || false,
          superBowlGewinner: config.superBowlGewinner || null,
          superBowlGewinnerLogo: config.superBowlGewinnerLogo || null,
          superBowlLogo: config.superBowlLogo || null,
          infoText: config.infoText || ''
        });
      }
      
      // Sortiere: Neueste zuerst
      saisonDaten.sort((a, b) => {
        const yearA = parseInt(a.id.split('-')[0]);
        const yearB = parseInt(b.id.split('-')[0]);
        return yearB - yearA;
      });
      
      setSaisons(saisonDaten);
      setLoading(false);
    } catch (error) {
      console.error('Fehler beim Laden der Saisons:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <div style={{ 
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <h2>Lade Saisons...</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden'
    }}>
      
      {/* HINTERGRUND mit Team-Logos 
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        opacity: 0.2,
        pointerEvents: 'none'
      }}>
        {/* Team-Logos Grid 
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(8, 1fr)',
          gap: '40px',
          padding: '40px',
          transform: 'rotate(-5deg) scale(1.1)'
        }}>
          {[...NFL_TEAM_LOGOS, ...NFL_TEAM_LOGOS].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt=""
              style={{
                width: '100%',
                height: 'auto',
                opacity: 0.3
              }}
            />
          ))}
        </div>
      </div>*/}

      {/* CONTENT */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '40px 20px'
      }}>
        {/* Header mit NFL Logo */}
        <div style={{
          textAlign: 'center',
          marginBottom: '60px'
        }}>
          <img
            src={NFL_LOGO}
            alt="NFL"
            style={{
              width: '120px',
              height: 'auto',
              marginBottom: '20px'
            }}
          />
          <h1 style={{
            fontSize: '48px',
            fontWeight: 'bold',
            marginBottom: '10px',
            background: 'linear-gradient(135deg, #013369 0%, #D50A0A 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            NFL Tippspiel
          </h1>
          <p style={{ fontSize: '20px', color: '#666' }}>
            Wähle eine Saison aus
          </p>
        </div>

        {/* Saison-Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px',
          marginBottom: '40px'
        }}>
          {saisons.map((saison) => (
            <div
              key={saison.id}
              onClick={() => navigate(`/tippspiel/${saison.id}`)}
              style={{
                backgroundColor: 'white',
                borderRadius: '20px',
                padding: '30px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                border: '3px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                e.currentTarget.style.borderColor = '#013369';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              {/* Status Badge */}
              <div style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                backgroundColor: saison.gesperrt ? '#dc3545' : '#28a745',
                color: 'white'
              }}>
                {saison.gesperrt ? '🔒 Abgeschlossen' : '🟢 Aktiv'}
              </div>

              {/* Super Bowl Logo (wenn vorhanden) */}
              {saison.superBowlLogo && (
                <div style={{
                  textAlign: 'center',
                  marginBottom: '20px'
                }}>
                  <img
                    src={saison.superBowlLogo}
                    alt="Super Bowl"
                    style={{
                      maxWidth: '200px',
                      height: 'auto',
                      opacity: 0.9
                    }}
                    onError={(e) => e.target.style.display = 'none'}
                  />
                </div>
              )}

              {/* Saison-Name */}
              <h2 style={{
                fontSize: '36px',
                fontWeight: 'bold',
                marginBottom: '15px',
                textAlign: 'center'
              }}>
                Saison {saison.name}
              </h2>

              {/* Super Bowl Gewinner (nur bei gesperrten Saisons) */}
              {saison.gesperrt && saison.superBowlGewinnerLogo && (
                <div style={{
                  marginTop: '25px',
                  padding: '25px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '15px',
                  border: '2px solid #d1d1d1'
                }}>
                  <p style={{
                    textAlign: 'center',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '15px',
                    letterSpacing: '1px'
                  }}>
                    🏆 SUPER BOWL CHAMPION
                  </p>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <img
                      src={saison.superBowlGewinnerLogo}
                      alt={saison.superBowlGewinner}
                      style={{
                        maxWidth: '140px',
                        height: 'auto',
                        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.15))'
                      }}
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  </div>
                </div>
              )}

              {/* Info-Text (falls vorhanden) */}
              {saison.infoText && (
                <div style={{
                  marginTop: '20px',
                  padding: '15px',
                  backgroundColor: '#e7f3ff',
                  borderRadius: '10px',
                  fontSize: '14px',
                  color: '#0c5460'
                }}>
                  ℹ️ {saison.infoText}
                </div>
              )}

              {/* Call to Action */}
              <div style={{
                marginTop: '25px',
                textAlign: 'center'
              }}>
                <div style={{
                  display: 'inline-block',
                  padding: '12px 30px',
                  backgroundColor: '#013369',
                  color: 'white',
                  borderRadius: '25px',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}>
                  {saison.gesperrt ? '📊 Statistiken ansehen' : '🏈 Jetzt tippen'}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer mit NFL Branding */}
        <div style={{
          textAlign: 'center',
          marginTop: '60px',
          padding: '40px',
          borderTop: '2px solid #ddd'
        }}>
          <img
            src={NFL_LOGO}
            alt="NFL"
            style={{
              width: '80px',
              height: 'auto',
              opacity: 0.5,
              marginBottom: '15px'
            }}
          />
          <p style={{ color: '#999', fontSize: '14px' }}>
            Inoffizielles NFL Tippspiel
          </p>
        </div>
      </div>
    </div>
  );
}

export default SaisonAuswahlPage;
